module.exports = __webpack_public_path__ + "images/website-3_websites-desktop-april2019-87c06e9bd860fe520774f3fd7b9139a5.jpg";